var exports = {
  "T": "x7f9a0e16--2e66d1--advantages",
};

module.exports = exports;
